export const USD_DECIMAL_PRECISION = 2;
export const USD_SIGN = '$';

export const PERCENTAGE_DECIMAL_PRECISION = 2;
